import * as types from './types';

const initialState = {
  GetResourceMobilization: {},
  PostResourceMobilization: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };
    case types.GET_RESOURCE_MOBILIZATION_SUCCESS: {
      return {
        ...state,
        GetResourceMobilization: action.payload
      };
    }
    case types.GET_RESOURCE_MOBILIZATION_FAILURE:
      return { ...state, error: action.payload };

    case types.POST_RESOURCE_MOBILIZATION_SUCCESS: {
      return {
        ...state,
        PostResourceMobilization: action.payload
      };
    }
    case types.POST_RESOURCE_MOBILIZATION_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
